import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-select-vendor-item",
  templateUrl: "./select-item.component.html",
  styleUrls: ["./select-item.component.scss"],
})
export class SelectVendorItemComponent implements OnInit,OnDestroy{
  @Input() vendor: any;
  image: string;
  private destroy$ = new Subject<void>();
  constructor() {}

  ngOnInit(): void {
    this.image = 'assets/images/No_image.png'
  }

  stopPropagation(e) {
    e.stopPropagation();
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
